// Role definitions and permissions
export const ROLES = {
  SUPER_ADMIN: {
    id: 'super_admin',
    name: 'Super Admin',
    level: 1,
    permissions: ['all']
  },
  HR_MANAGER: {
    id: 'hr_manager',
    name: 'HR Manager',
    level: 2,
    permissions: ['employee_create', 'employee_edit', 'employee_view', 'attendance_manage', 'leave_manage', 'payroll_manage', 'document_manage', 'performance_manage', 'report_view']
  },
  DEPARTMENT_HEAD: {
    id: 'department_head',
    name: 'Department Head',
    level: 3,
    permissions: ['employee_view', 'attendance_view', 'leave_approve', 'task_assign', 'performance_view']
  },
  TEAM_LEAD: {
    id: 'team_lead',
    name: 'Team Lead',
    level: 4,
    permissions: ['employee_view', 'task_assign', 'task_view', 'attendance_view']
  },
  EMPLOYEE: {
    id: 'employee',
    name: 'Employee',
    level: 5,
    permissions: ['dashboard_view', 'self_view', 'leave_view', 'leave_apply', 'task_view', 'document_view', 'attendance_view', 'report_view']
  }
};

// Department definitions
export const DEPARTMENTS = [
  'Engineering',
  'Sales',
  'Marketing',
  'HR',
  'Finance',
  'Operations',
  'IT Support',
  'Customer Service'
];

// Designation by role
export const DESIGNATIONS = {
  super_admin: ['CEO', 'CTO', 'COO', 'Managing Director'],
  hr_manager: ['HR Manager', 'HR Director', 'Talent Acquisition Manager'],
  department_head: ['Engineering Manager', 'Sales Director', 'Marketing Head', 'Department Manager'],
  team_lead: ['Team Lead', 'Senior Team Lead', 'Project Lead'],
  employee: ['Junior Developer', 'Senior Developer', 'Sales Executive', 'Marketing Executive', 'Accountant', 'Support Engineer']
};

// Permission checker
export const hasPermission = (userRole, permission) => {
  const role = Object.values(ROLES).find(r => r.id === userRole);
  if (!role) return false;
  return role.permissions.includes('all') || role.permissions.includes(permission);
};

// Get role by ID
export const getRoleById = (roleId) => {
  return Object.values(ROLES).find(r => r.id === roleId);
};

// Get all roles
export const getAllRoles = () => {
  return Object.values(ROLES);
};

// Check if role can create employee with target role
export const canCreateRole = (userRole, targetRole) => {
  const user = getRoleById(userRole);
  const target = getRoleById(targetRole);
  
  if (!user || !target) return false;
  
  // Super admin can create anyone
  if (user.permissions.includes('all')) return true;
  
  // HR Manager can create department heads and below
  if (user.id === 'hr_manager' && target.level >= 3) return true;
  
  // Department heads can create team leads and employees
  if (user.id === 'department_head' && target.level >= 4) return true;
  
  return false;
};

// Employee model
export const createEmployee = (data) => {
  return {
    id: data.id || `EMP${String(Date.now()).slice(-6)}`,
    name: data.name,
    email: data.email,
    phone: data.phone,
    role: data.role,
    department: data.department,
    designation: data.designation,
    dateOfJoining: data.dateOfJoining || new Date().toISOString().split('T')[0],
    salary: data.salary,
    reportingTo: data.reportingTo,
    status: data.status || 'active',
    documents: data.documents || [],
    createdBy: data.createdBy,
    createdAt: data.createdAt || new Date().toISOString()
  };
};
